<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__companies}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          
          <el-select v-model="dataForm.name" filterable clearable placeholder="公司查询">
	          <el-option
	                  v-for="item in nameList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
        </el-form-item>

      <el-form-item >
          <el-select v-model="dataForm.status" filterable clearable placeholder="状态查询">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>

      

       
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:companies:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:companies:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="公司名称" width="240px" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="standard" label="公司运营方式" header-align="center" align="center">
          <template slot-scope="scope">
               <el-tag v-if="scope.row.standard == 1"  size="small">标准化</el-tag>
               <el-tag v-else type="warning" size="small">非标准化</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ip" label="公司IP" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="logo" label="公司唯一标识" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="token" label="密钥" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address" label="公司地址" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="url" label="推送URL" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="公司邮箱" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" header-align="center" align="center" >
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.status === 0" size="small">无效</el-tag>
	            <el-tag v-if="scope.row.status === 1" size="small">有效</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="version" label="版本" header-align="center" align="center">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.version == 1" size="small">旧版本</el-tag>
	            <el-tag v-if="scope.row.version == 2" size="small">新版本</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="creatorName" label="创建人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateName" label="更新人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dockingPartySystem" label="对接方系统" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deptName" label="部门" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="repeat" label="是否去重" header-align="center" align="center">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.repeatFlag === 0" size="danger">否</el-tag>
	            <el-tag v-if="scope.row.repeatFlag === 1" size="small">是</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="repeatUrl" label="去重URL" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="repeatKey" label="去重密钥" header-align="center" align="center" show-overflow-tooltip></el-table-column>

        <el-table-column prop="formReturn" label="有效表单规则" header-align="center" align="center" show-overflow-tooltip> 
          <template slot-scope="scope">
	            <el-tag v-if="scope.row.formReturn === '0'" size="danger">无效</el-tag>
	            <el-tag v-else size="small">有效</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="earlyWarning" label="预警" header-align="center" align="center" show-overflow-tooltip> 
          <template slot-scope="scope">
	            <el-tag v-if="scope.row.earlyWarning === 0" size="danger">关</el-tag>
	            <el-tag v-else size="small">开</el-tag>
        	</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:companies:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:companies:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { getCompanies } from '../../../api/list'
import AddOrUpdate from './companies-add-or-update'
export default {
  mixins: [mixinViewModule],
 async mounted(){
    let res = await getCompanies()
    if(res.data.code == 0){
     this.nameList = res.data.data.list.map(item => ({value:item.name,label:item.name,}))
    }else{
      this.$mesage.error(res.data.msg)
    }
    
  },
  data () {
   
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/companies/page',
        getDataListIsPage: true,
        exportURL: '/sys/companies/export',
        deleteURL: '/sys/companies',
        deleteIsBatch: true,
        
      },
      nameList:[],
      dataForm: {
        id: '',
        name:'',
        status:'',
      },
     
      statusList:[
        {
            'label':'停用',
            'value':0,
        },
        {
            'label':'正常',
            'value':1,
        }
      ],
    }
  },
  methods:{
   
  },
  components: {
    AddOrUpdate
  }
}
</script>
